var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "recent-updates" }, [
    _c("h3", { staticClass: "mb-3" }, [_vm._v("Recent Updates")]),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", [
          _c(
            "ul",
            { staticClass: "rows" },
            _vm._l(_vm.updates, function(update, index) {
              return _c(
                "li",
                {
                  staticClass: "row py-2 px-3",
                  class: {
                    "t-navy": index % 2 === 0,
                    "bg-white": index % 2 !== 0
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row__content d-flex flex-column" },
                    [
                      _c("div", { staticClass: "row__heading mb-1" }, [
                        _vm._v(_vm._s(_vm.formattedDate(update)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row__paragraph t-navy" }, [
                        _vm._v(_vm._s(_vm.title(update)))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-ghost btn-small",
                      attrs: { href: _vm.modelUrl(update) }
                    },
                    [_vm._v("View")]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "content-loader" },
            [
              _c(
                "ContentLoader",
                {
                  attrs: {
                    height: 500,
                    width: 720,
                    speed: 2,
                    primaryColor: "#f3f3f3",
                    secondaryColor: "#ecebeb"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "0",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "72",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "144",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "216",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "288",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "360",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "432",
                      rx: "0",
                      ry: "0",
                      width: "720",
                      height: "56"
                    }
                  })
                ]
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b6e1bd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6e1bd8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RecentUpdates.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1b6e1bd8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RecentUpdates.vue
// module chunks = 0 1